import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import HotelCardSeo from '@lt/components/components/HotelCard/index';
import HotelCardSmall from '@lt/components/components/HotelCardSmall/index';

import { hotelImagesByIdSelector } from 'src/store/hotelImages/selectors';
import Wishlist from 'src/components/Wishlist';

import { Close } from '@lt/components/icons-react';
import classnames from 'classnames';
import styles from './hotelCard.module.css';

export const HotelCardRender = ({
  isMobile,
  isSmallCard = false,
  activateCashbackForPartner,
  loadAllImages,
  isHotelCardFromMap,
  hasLabel,
  onClosePopup,
  ...otherProps
}) => {
  const bonusCount = activateCashbackForPartner
    ? otherProps?.bonus_count
    : null;
  const hotelId = otherProps.hotel.id;

  const loadedImages = useSelector((state) =>
    hotelImagesByIdSelector(state, hotelId),
  );
  const defaultImages = otherProps.images.list;

  const imagesList = loadedImages?.length ? loadedImages : defaultImages;
  const onSlideChange = loadAllImages ? () => loadAllImages() : undefined;

  const hotelCardProps = {
    ...otherProps,
    isMapCard: isHotelCardFromMap,
    bonus_count: bonusCount,
    images: {
      list: imagesList,
      count: imagesList.length,
      onSlideChange,
    },
  };

  return (
    <div className={styles.relativeWrapper}>
      {isMobile && (
        <HotelCardSmall
          className={styles.hotelCardSmall}
          {...hotelCardProps}
          isMobile
        />
      )}
      {!isMobile && isSmallCard && (
        <HotelCardSmall
          className={styles.hotelCardSmall}
          {...hotelCardProps}
          isMobile={false}
        />
      )}
      {!isMobile && !isSmallCard && (
        <HotelCardSeo className={styles.hotelCardSeo} {...hotelCardProps} />
      )}
      <Wishlist
        className={classnames(styles.wishlist, {
          [styles.wishlistHotelCardFromMap]: isHotelCardFromMap,
          [styles.wishlistHotelCardFromMapWithLabel]:
            isHotelCardFromMap && hasLabel,
        })}
        type="hotel"
        wishlistIdentifier={hotelId}
        isWhiteHeart={isSmallCard}
        isHotelCardFromMap={isHotelCardFromMap}
        $hasLabel={hasLabel}
      />
      {!isMobile && isHotelCardFromMap && (
        <button
          className={styles.closeButton}
          onClick={onClosePopup}
          type="button"
        >
          <Close className={styles.closeIcon} width={12} />
        </button>
      )}
    </div>
  );
};

export const HotelCard = HotelCardRender;

HotelCard.defaultProps = {
  isMobile: false,
};

HotelCard.propTypes = {
  isMobile: PropTypes.bool,
};
